export default __webpack_public_path__ + "4ffb74b03d727728f474c92c43acae87.png";